import { MedalRank } from 'app/modules/insights/components/MedalRankBadge';

export function getMedalRankFromIndex(index: number): MedalRank | undefined {
  return (['gold', 'silver', 'bronze'] as const)[index];
}
